import React from "react"
import {Meta, Resource} from "../../resources/common"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import ProductApplicationRow from "./ProductApplicationRow"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import {
	AllowedProductApplicationsColumns,
	ProductApplication,
	ProductApplicationsColumns,
} from "../../resources/productApplication"

interface ProductApplicationsTableProps {
	productApplications: Array<ProductApplication>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: Array<AllowedProductApplicationsColumns>
	fullHeight?: boolean
	showTabsOnHeader?: boolean
	meta?: Meta
	isFiltering?: boolean
	sortFunction: () => void
	sortBy: string
}

export default function ProductApplicationsTable({
	productApplications,
	hasResults,
	hasPrev,
	hasNext,
	prev,
	next,
	isUsingPaging,
	include,
	includedColumns,
	fullHeight,
	showTabsOnHeader,
	meta,
	sortFunction,
	sortBy,
}: ProductApplicationsTableProps) {
	return (
		<div className={"product-applications-table"}>
			<DataTable
				isEmpty={productApplications.length === 0}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				stickyActionWithTabsOnHeader={fullHeight && showTabsOnHeader}
				noContentText={"No product applications found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							if (column[1] === ProductApplicationsColumns.createdAt) {
								return (
									<DataTableCell
										clickable
										onClick={() => sortFunction()}
										key={column[1]}
										sortable
										sortApplied={sortBy === "createdAt"}
									>
										{column[1]}
									</DataTableCell>
								)
							}
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{productApplications.map((productApplication) => (
						<ProductApplicationRow
							key={productApplication.id}
							productApplication={productApplication}
							includedColumns={includedColumns}
							include={include}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
